/* tslint:disable:no-access-missing-member */
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Host,
    Input,
    OnInit,
    QueryList,
    ViewChildren,
} from '@angular/core';
import { takeUntil } from 'rxjs/operators';

import { NDDFormErrorService } from '../ndd-ng-form-error/shared/ndd-ng-form-error.service';
import { NDDFormRadioBtnGroupComponent } from '../ndd-ng-form-radio-btn-group/ndd-ng-form-radio-btn-group.component';
import { NDDFormsBaseComponent } from '../shared/ndd-ng-forms.base-component';

/** Componente de botão de radio*/
@Component({
    selector: 'ndd-ng-form-radio-btn',
    template: require('./ndd-ng-form-radio-btn.component.html'),
})
export class NDDFormRadioBtnComponent extends NDDFormsBaseComponent implements OnInit, AfterViewInit {
    /** Define se está marcado (checked). */
    @Input() public controlChecked: boolean;

    /** Define o ícone do radio btn */
    @Input() public controlIcon: String;

    public controlBtnLarge: boolean;

    public controlFocus: boolean;

    @ViewChildren('inputRadioRef') private inputElement: QueryList<ElementRef>;

    // É esperado que se utilize o ndd-form-radio-btn com o seu group
    // Isso evita a repetição de propriedades como key, form, large etc.
    constructor(formErrorService: NDDFormErrorService, cdr: ChangeDetectorRef, @Host() private parent: NDDFormRadioBtnGroupComponent,
        private elementRef: ElementRef) {
        super(formErrorService, cdr);
    }

    public ngOnInit(): void {
        this.readPropertiesFromParent();
        if (this.controlChecked) {
            this.control.setValue(this.controlValue);
        }
    }

    public ngAfterViewInit(): void {
        // Ao modificar o valor o control, atualizamos o valor de controlChecked
        this.control.valueChanges.pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe(() => {
                this.controlChecked = this.control.value === this.controlValue;
            });
    }

    public toggleFocus(): void {
        this.controlFocus = !this.controlFocus;
    }

    public onCheck(): void {
        this.control.setValue(this.controlValue);
        this.updateValidity();

        this.inputElement.first.nativeElement.focus();
        this.controlValueChange.emit(this.controlValue);
    }

    protected updateValidity(): void {
        super.updateValidity();

        if (!this.control.dirty) {
            this.control.markAsDirty();
            this.control.updateValueAndValidity();
        }
    }

    private readPropertiesFromParent(): void {
        this.control = this.parent.getControl();
        this.controlKey = this.parent.controlKey;
        this.controlForm = this.parent.controlForm;
        this.controlBtnLarge = this.parent.controlBtnLarge;
        this.controlDisabled = this.parent.controlDisabled;
        if (this.parent.controlMaxWidthBtn) {
            this.elementRef.nativeElement.style.maxWidth = this.parent.controlMaxWidthBtn;
        }
    }
}
